export default () => JSON.parse(window.remoteConfig.getString('checkout_ctas'))
